// extracted by mini-css-extract-plugin
export default {"statRow":"qcfzkzhOudk3EtNQBTVu","statValue":"Rl4dugXMFJYX2zEtC5xC"};